import User from "../../Models/User";
import Branch from "../../Models/Branch";

export const GET_LOGIN = "Auth/getLogin";
export const GET_CURRENT_USER = "Auth/getCurrentUser";
export const LOGOUT = "Auth/logout";
export const FORGOT_PASSWORD = "Auth/forgotPassword";
export const RECOVER_PASSWORD = "Auth/recoverPassword";
export const CHANGE_PASSWORD = "Auth/changePassword";

export interface LoginBody {
  login: string,
  password: string
}

export type BranchesMap = {[key: string]: Branch};

export interface AuthState {
  state: string,
  user: User,
  logged: boolean,
  token: string | null,
  branches: Branch[],
  branchesMap?: BranchesMap,
  branchOptions?: Array<{label: string, value: string}>,
  currentBranch: Branch
}

export interface RecoverPasswordParams {
  code: string,
  password: string,
  repeatPassword?: string,
  user_id: string,
}
